import { normalizeKanunMaddeleri } from '../utils/kanunMaddeNormalizasyon.js';

// Şablon "AI ile Geliştir" — Gemini'ye gönderilen talimat.
//
// ÖNEMLİ: Buradaki çıktı formatı (Özet:/Başlık:/Etiketler:/Kanun Maddeleri:)
// aşağıdaki parseSablonGelistirYaniti() regex'leriyle bir SÖZLEŞMEDİR.
// Formatı değiştirirsen parser'ı da güncelle.
export const buildSablonGelistirPrompt = ({ icerik, tumEtiketler = [], tumKanunMaddeleri = [] }) => `
  Sen bir Yargıtay kararı uzmanısın. Aşağıdaki metni analiz et ve şu görevleri yerine getir:
  1. Metnin kısa bir özetini oluştur (maksimum 2 cümle ve en fazla toplam 300 karakter). Özet, kararın ana noktalarını ve bozma ya da onama kararının temel gerekçesini/gerekçelerini içermeli. Eğer öninceleme bölümünde istisnai bir durum varsa, o da özete dahil edilmelidir.
  2. Metin için uygun ve spesifik bir başlık öner (maksimum 100 karakter). Başlık, kararın konusunu ve ana hukuki meseleyi yansıtmalı.
  3. Metne uygun 5 etiket öner. Etiketler, kararda geçen spesifik hukuki kavramlar veya özel durumlar olmalı. Genel kavramlardan (örn. 'ceza', 'yargıtay') kaçınılmalı.
  4. Metinde geçen ilgili kanun maddelerini belirle ve listele. Kanun maddelerini KESİNLİKLE şu kanonik formatta yaz: "KISALTMA m. <madde>[/<fıkra>[-<bent>]]". Örnekler: "TCK m. 58", "TCK m. 50/1-a", "CMK m. 100/2". Kanun adını HER ZAMAN kısaltmayla ver (örn. "Türk Ceza Kanunu" veya "5237 sayılı Kanun" yerine "TCK"). Aşağıdaki "Mevcut kanun maddeleri" listesinde uygun bir kanonik etiket varsa onu birebir kullan.

  Mevcut etiketler: ${tumEtiketler.join(', ')}
  Mevcut kanun maddeleri: ${tumKanunMaddeleri.join(', ')}

  Metin:
  ${icerik}

  Yanıtını şu formatta ver:
  Özet: [özet]
  Başlık: [başlık]
  Etiketler: [etiket1], [etiket2], [etiket3], [etiket4], [etiket5]
  Kanun Maddeleri: [madde1], [madde2], [madde3], ...
`;

// Yukarıdaki prompt'un istediği formattaki AI yanıtını ayrıştırır.
// Dönüş: { ozet, baslik, etiketler, kanunMaddeleri }
export const parseSablonGelistirYaniti = (aiResponse) => {
  const ozet = aiResponse.match(/Özet: (.*)/)?.[1] || '';
  const baslik = aiResponse.match(/Başlık: (.*)/)?.[1] || '';
  const etiketler = aiResponse.match(/Etiketler: (.*)/)?.[1]?.split(', ') || [];
  const kanunMaddeleri = normalizeKanunMaddeleri(aiResponse.match(/Kanun Maddeleri: (.*)/)?.[1]?.split(', ') || []);
  return { ozet, baslik, etiketler, kanunMaddeleri };
};
